<template>
  <div
    class="border-component"
    :style="{
      backgroundColor: borderBackground,
      border:borderWidth + 'px solid '+ borderColor,
      borderRadius: borderRadius + 'px'
    }">
    <template v-if="config.chartSet.chartStyle.hasCorner">
      <template v-if="config.chartSet.chartStyle.borderType === 1">
        <svg class="number-bg number-bg1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g data-name="组 34605" transform="translate(-1286 -390)">
            <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,0H2L0,18H0Z" transform="translate(1286 390)" />
            <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,0H0L2,18H0Z" transform="translate(1304 390) rotate(90)" />
          </g>
        </svg>
        <svg class="number-bg number-bg2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M2,0H0L2,18H2Z" transform="translate(16)" />
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,18H0L2,0H0Z" transform="translate(18) rotate(90)" />
        </svg>
        <svg class="number-bg number-bg3" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M2,18H0L2,0H2Z" transform="translate(16)" />
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,0H0L2,18H0Z" transform="translate(0 18) rotate(-90)" />
        </svg>
        <svg class="number-bg number-bg4" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,18H2L0,0H0Z" />
          <path :style="{fill: config.chartSet.chartStyle.cornerColor}" d="M0,18H0L2,0H0Z" transform="translate(0 18) rotate(-90)" />
        </svg>
      </template>
      <template v-else-if="config.chartSet.chartStyle.borderType === 2">
        <svg class="number-bg number-bg1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g data-name="组 34602" transform="translate(0 0)">
            <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34593">
              <path data-name="减去 39" d="M6 6H0V0h6v6ZM1.2 1.2v3.6h3.6V1.2Z" />
              <path d="M2 2h2v2H2z" data-name="矩形 10695" />
              <path d="M8 0h2v2H8z" data-name="矩形 10690" />
              <path d="M0 10V8h2v2z" data-name="矩形 10693" />
              <path d="M12 0h1v1h-1z" data-name="矩形 10691" />
              <path d="M0 13v-1h1v1z" data-name="矩形 10692" />
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g data-name="组 34602" transform="translate(18 0) rotate(90)">
            <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34593">
              <path data-name="减去 39" d="M6 6H0V0h6v6ZM1.2 1.2v3.6h3.6V1.2Z" />
              <path d="M2 2h2v2H2z" data-name="矩形 10695" />
              <path d="M8 0h2v2H8z" data-name="矩形 10690" />
              <path d="M0 10V8h2v2z" data-name="矩形 10693" />
              <path d="M12 0h1v1h-1z" data-name="矩形 10691" />
              <path d="M0 13v-1h1v1z" data-name="矩形 10692" />
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg3" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g data-name="组 34602" transform="translate(18 18) rotate(180)">
            <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34593">
              <path data-name="减去 39" d="M6 6H0V0h6v6ZM1.2 1.2v3.6h3.6V1.2Z" />
              <path d="M2 2h2v2H2z" data-name="矩形 10695" />
              <path d="M8 0h2v2H8z" data-name="矩形 10690" />
              <path d="M0 10V8h2v2z" data-name="矩形 10693" />
              <path d="M12 0h1v1h-1z" data-name="矩形 10691" />
              <path d="M0 13v-1h1v1z" data-name="矩形 10692" />
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg4" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g data-name="组 34602" transform="translate(0 18) rotate(-90)">
            <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34593">
              <path data-name="减去 39" d="M6 6H0V0h6v6ZM1.2 1.2v3.6h3.6V1.2Z" />
              <path d="M2 2h2v2H2z" data-name="矩形 10695" />
              <path d="M8 0h2v2H8z" data-name="矩形 10690" />
              <path d="M0 10V8h2v2z" data-name="矩形 10693" />
              <path d="M12 0h1v1h-1z" data-name="矩形 10691" />
              <path d="M0 13v-1h1v1z" data-name="矩形 10692" />
            </g>
          </g>
        </svg>
      </template>
      <template v-else-if="config.chartSet.chartStyle.borderType === 3">
        <svg class="number-bg number-bg1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34604" transform="translate(0 0)">
            <g data-name="组 34600">
              <path data-name="路径 17864" d="M2.442 2.44v4.882L7.324 2.44Z" />
              <g data-name="组 34599">
                <path data-name="减去 40" d="M0 10V0h10L8.753 1.247h-7.5v7.5L0 10Z" />
              </g>
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34604" transform="translate(18 0) rotate(90)">
            <g data-name="组 34600">
              <path data-name="路径 17864" d="M2.442 2.44v4.882L7.324 2.44Z" />
              <g data-name="组 34599">
                <path data-name="减去 40" d="M0 10V0h10L8.753 1.247h-7.5v7.5L0 10Z" />
              </g>
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg3" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34604" transform="translate(18 18) rotate(180)">
            <g data-name="组 34600">
              <path data-name="路径 17864" d="M2.442 2.44v4.882L7.324 2.44Z" />
              <g data-name="组 34599">
                <path data-name="减去 40" d="M0 10V0h10L8.753 1.247h-7.5v7.5L0 10Z" />
              </g>
            </g>
          </g>
        </svg>
        <svg class="number-bg number-bg4" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34604" transform="translate(0 18) rotate(-90)">
            <g data-name="组 34600">
              <path data-name="路径 17864" d="M2.442 2.44v4.882L7.324 2.44Z" />
              <g data-name="组 34599">
                <path data-name="减去 40" d="M0 10V0h10L8.753 1.247h-7.5v7.5L0 10Z" />
              </g>
            </g>
          </g>
        </svg>
      </template>
      <template v-else-if="config.chartSet.chartStyle.borderType === 4">
        <svg class="number-bg number-bg1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34603" transform="translate(0 0)">
            <path data-name="联合 41" d="m14.401 4-2.216-2.286h3.6L18.001 4ZM9.138 4 6.092.857h3.6L12.737 4ZM3.875 4 0 0h3.6l3.877 4Z" />
          </g>
        </svg>
        <svg class="number-bg number-bg2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18" style="transform: rotateY(180deg)">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34603">
            <path data-name="联合 41" d="m14.401 4-2.216-2.286h3.6L18.001 4ZM9.138 4 6.092.857h3.6L12.737 4ZM3.875 4 0 0h3.6l3.877 4Z" />
          </g>
        </svg>
        <svg class="number-bg number-bg3" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34603" transform="translate(18 18) rotate(180)">
            <path data-name="联合 41" d="m14.401 4-2.216-2.286h3.6L18.001 4ZM9.138 4 6.092.857h3.6L12.737 4ZM3.875 4 0 0h3.6l3.877 4Z" />
          </g>
        </svg>
        <svg class="number-bg number-bg4" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18.001 18" style="transform: rotateX(180deg)">
          <g :style="{fill: config.chartSet.chartStyle.cornerColor}" data-name="组 34603">
            <path data-name="联合 41" d="m14.401 4-2.216-2.286h3.6L18.001 4ZM9.138 4 6.092.857h3.6L12.737 4ZM3.875 4 0 0h3.6l3.877 4Z" />
          </g>
        </svg>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BorderComponent',
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
  },

  computed: {
    borderBackground () {
      return this.config.chartSet.chartStyle.background
    },
    borderColor () {
      return this.config.chartSet.chartStyle.borderColor
    },
    borderRadius () {
      return this.config.chartSet.chartStyle.borderRadius
    },
    borderWidth () {
      return this.config.chartSet.chartStyle.borderWidth
    },
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
.border-component{
  width: 100%;
  height: 100%;
  .number-bg{
    position: absolute;
    &.number-bg1{
      left: 0;
      top: 0;
    }
    &.number-bg2{
      right: 0;
      top: 0;
    }
    &.number-bg3{
      bottom: 0;
      right: 0;
    }
    &.number-bg4{
      left: 0;
      bottom: 0;
    }
    &.number-bg5{
      top: 0;
    }
    &.number-bg6{
      bottom: 0;
    }
    .a {
      // opacity: 0.15;
      fill: #0276fa;
    }
  }
}
</style>
